<template>
  <div v-if="player.username">
    <GamePlayerAi
      v-if="player.aiLevel"
      ref="player"
      :color="color"
      :aiEngine="player.aiEngine || defaultEngine"
      :aiLevel="player.aiLevel"
      :lastMove="lastMove"
    />
    <GamePlayerReal v-else ref="player" :color="color" />
  </div>
</template>

<script>
import { CHESS_ENGINE } from "vue-chess-shared/constants";
import GamePlayerAi from "./GamePlayerAi";
import GamePlayerReal from "./GamePlayerReal";

export default {
  name: "GamePlayerFactory",

  components: { GamePlayerAi, GamePlayerReal },

  data() {
    return {
      defaultEngine: CHESS_ENGINE.STOCKFISH,
    };
  },

  props: {
    color: {
      type: String,
      default: "",
    },
    player: {
      type: Object,
      default: () => {},
    },
    lastMove: {
      type: Object,
      default: null,
    },
  },
};
</script>
